import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Button from '@Components/Button';
import DialogsWithIcon from '../DialogsWithIcon';

import './DialogWithWarningLayout.scss';

export default function DialogWithWarningLayout(props) {
  const { children, onYesClick, selfClose, character, footerClassName, yesLabel } = props;

  const clickHandler = () => {
    selfClose();
    if (onYesClick) {
      onYesClick();
    }
  };

  return (
    <DialogsWithIcon
      {...props}
      character={character || 'i'}
      layoutType="error"
      headerClassName="dialog-with-warning-layout-header"
      footerClassName={classnames(footerClassName, 'dialog-with-warning-layout-footer-wrapper')}
      footer={
        <Button
          buttonConfig={{ type: 'primary', size: 'sm', label: yesLabel, e2eName: 'dialog-warning-ok' }}
          iconConfig={{ name: 'chevron-right', size: 'tiny' }}
          onClick={clickHandler}
        />
      }>
      {children}
    </DialogsWithIcon>
  );
}

DialogWithWarningLayout.defaultProps = {
  yesLabel: 'Ok',
};

export const propTypes = {
  selfClose: PropTypes.func.isRequired,
  onYesClick: PropTypes.func,
  yesLabel: PropTypes.string,
  character: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  footerClassName: PropTypes.string,
  children: PropTypes.node,
};

DialogWithWarningLayout.propTypes = propTypes;
